import React, { useState } from 'react';

import {Items, useFetch} from '@thinkwell/react.common';
const CoursesContext = React.createContext([{}, () => {}, {}, () => {}, () => {}, () => {}]);

const CoursesProvider = (props) => {
  const [items, setItems, upsertItem, getItem, deleteItem] = Items(useState(props && props.value || []))
  const [fetchCoursesState, fetchCourses] = useFetch({onSuccess: setItems})

  return (
    <CoursesContext.Provider value={[items, fetchCourses, fetchCoursesState, upsertItem, getItem, deleteItem]}>
      {props.children}
    </CoursesContext.Provider>
  );
};

export { CoursesContext, CoursesProvider}
